import {filters} from "@atttomyx/shared-constants";
import {arrays, datetime, formatters, objects} from "@atttomyx/shared-utils";
import {nodeUtils} from "./utils";
import {NODE_ANONYMOUS} from "./constants";

export const USER_FILTERS = {
    firstName: {
        label: "first name",
        type: filters.TYPE_STRING,
    },
    lastName: {
        label: "last name",
        type: filters.TYPE_STRING,
    },
    type: {
        type: filters.TYPE_STRING,
        getter: (item) => item.settings.type,
    },
};

export const NODE_FILTERS = {
    firstName: {
        label: "first name",
        type: filters.TYPE_STRING,
    },
    lastName: {
        label: "last name",
        type: filters.TYPE_STRING,
    },
    phone: {
        type: filters.TYPE_STRING,
        getter: (item) => nodeUtils.getValues(item.phones),
    },
    email: {
        type: filters.TYPE_STRING,
        getter: (item) => nodeUtils.getValues(item.emails),
    },
    url: {
        type: filters.TYPE_STRING,
        getter: (item) => nodeUtils.getValues(item.urls),
    },
    line1: {
        label: "line 1",
        type: filters.TYPE_STRING,
        getter: (item) => nodeUtils.getFields(item.addresses, "line1"),
    },
    line2: {
        label: "line 2",
        type: filters.TYPE_STRING,
        getter: (item) => nodeUtils.getFields(item.addresses, "line2"),
    },
    locality: {
        label: "city",
        type: filters.TYPE_STRING,
        getter: (item) => nodeUtils.getFields(item.addresses, "locality"),
    },
    region: {
        label: "state",
        type: filters.TYPE_STRING,
        getter: (item) => nodeUtils.getFields(item.addresses, "region"),
    },
    postalCode: {
        label: "postal code",
        type: filters.TYPE_STRING,
        getter: (item) => nodeUtils.getFields(item.addresses, "postalCode"),
    },
    country: {
        type: filters.TYPE_STRING,
        getter: (item) => nodeUtils.getFields(item.addresses, "country"),
    },
    date: {
        type: filters.TYPE_STRING,
        getter: (item) => nodeUtils.getValues(item.dates),
    },
    other: {
        type: filters.TYPE_STRING,
        getter: (item) => nodeUtils.getValues(item.others),
    },
    phoneExists: {
        label: "has phone",
        type: filters.TYPE_ARRAY,
        getter: (item) => nodeUtils.getLabels(item.phones),
    },
    emailExists: {
        label: "has email",
        type: filters.TYPE_ARRAY,
        getter: (item) => nodeUtils.getLabels(item.emails),
    },
    urlExists: {
        label: "has url",
        type: filters.TYPE_ARRAY,
        getter: (item) => nodeUtils.getLabels(item.urls),
    },
    addressExists: {
        label: "has address",
        type: filters.TYPE_ARRAY,
        getter: (item) => nodeUtils.getLabels(item.addresses),
    },
    dateExists: {
        label: "has date",
        type: filters.TYPE_ARRAY,
        getter: (item) => nodeUtils.getLabels(item.dates),
    },
    otherExists: {
        label: "has other",
        type: filters.TYPE_ARRAY,
        getter: (item) => nodeUtils.getLabels(item.others),
    },
    tagHas: {
        label: "has tag",
        type: filters.TYPE_ARRAY,
        getter: (item) => item.tags,
    },
    tagNot: {
        label: "does not have tag",
        type: filters.TYPE_ARRAY,
        not: true,
        getter: (item) => item.tags,
    },
};

export const BULK_EMAIL_FILTERS = {
    email: {
        label: "has email",
        type: filters.TYPE_ARRAY,
        getter: (item) => nodeUtils.getLabels(item.emails),
    },
};

export const getOfferingFilters = (nodes) => {
    const idToNode = arrays.getIdToEntity(nodes);

    return {
        nodeId: {
            label: "member",
            formatter: (value) => nodeUtils.getName(objects.defaultIfNullOrUndefined(idToNode[value], NODE_ANONYMOUS)),
        },
        category: {
            type: filters.TYPE_STRING,
        },
        type: {
            type: filters.TYPE_STRING,
        },
        minimum: {
            label: ">=",
            type: filters.TYPE_NUM_GREATER_THAN_OR_EQUAL_TO,
            getter: (item) => item.amount.dollars + (item.amount.cents / 100),
            formatter: formatters.usDollars,
        },
        maximum: {
            label: "<=",
            type: filters.TYPE_NUM_LESS_THAN_OR_EQUAL_TO,
            getter: (item) => item.amount.dollars + (item.amount.cents / 100),
            formatter: formatters.usDollars,
        },
        after: {
            type: filters.TYPE_STR_GREATER_THAN_OR_EQUAL_TO,
            getter: (item) => item.date,
            formatter: datetime.getFullDate,
        },
        before: {
            type: filters.TYPE_STR_LESS_THAN_OR_EQUAL_TO,
            getter: (item) => item.date,
            formatter: datetime.getFullDate,
        },
    }
};

export const getOfferingDefaults = () => {
    const now = datetime.now();
    const year = datetime.getYear(now);

    return {
        after: year + "-01-01",
        before: year + "-12-31",
    }
};
